import { runTextAnimation } from './text'

function runIntroAnimations()
{
  runTextAnimation($('.section-intro'), 0)
}

export { runIntroAnimations }
